export default "__VITE_ASSET__DAX3cJp2__"